import "./equipment.css";

/*
  중장비(지게차·굴삭기 등) 위치 표시. 센서·CCTV 같은 장비 종류(DEVICE_TYPES)와 따로 둔다 —
  연동 방식이 아직 정해지지 않아, 지도에는 다른 장비와 구분되는 모양으로 위치만 올린다.
  마커 모양은 2D 지도와 3D 뷰어가 같이 쓰고, 자리 잡기만 각 지도가 한다.
*/

export type EquipmentStatus = "WORKING" | "MOVING" | "IDLE";

export interface EquipmentPoint {
  id: string;
  /** 현장에서 부르는 이름 (지게차 1) */
  name: string;
  lat: number;
  lon: number;
  status: EquipmentStatus;
}

export const EQUIPMENT_STATUS: Record<EquipmentStatus, { label: string; color: string }> = {
  WORKING: { label: "작업 중", color: "#16a34a" },
  MOVING: { label: "이동 중", color: "#2563eb" },
  IDLE: { label: "대기", color: "#737373" },
};

/** 지게차 실루엣 (24×24 선 아이콘) */
export const EQUIPMENT_ICON_PATH =
  "M4 18V9h6l3 5v4M4 18h9M7 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm6 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM16 18V4M16 18h5";

const ICON_SVG = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="${EQUIPMENT_ICON_PATH}"/></svg>`;

export const equipmentTitle = (point: EquipmentPoint) =>
  `${point.name} · ${EQUIPMENT_STATUS[point.status].label}`;

/** 각진 주황 배지 + 상태 점 + 이름표. 둥근 장비 핀과 한눈에 구분된다. */
export function createEquipmentBadge(point: EquipmentPoint): HTMLDivElement {
  const badge = document.createElement("div");
  badge.className = "model-equipment";
  badge.innerHTML = `<span class="model-equipment__icon">${ICON_SVG}<span class="model-equipment__status"></span></span><span class="model-equipment__title"></span>`;
  updateEquipmentBadge(badge, point);
  return badge;
}

export function updateEquipmentBadge(badge: HTMLDivElement, point: EquipmentPoint) {
  const title = equipmentTitle(point);
  badge.title = title;
  badge.setAttribute("role", "img");
  badge.setAttribute("aria-label", title);
  const status = badge.querySelector<HTMLSpanElement>(".model-equipment__status");
  if (status) status.style.background = EQUIPMENT_STATUS[point.status].color;
  const label = badge.querySelector<HTMLSpanElement>(".model-equipment__title");
  if (label) label.textContent = title;
}
